import { render, staticRenderFns } from "./DataGroupAdd.vue?vue&type=template&id=369bf370&scoped=true&"
import script from "./DataGroupAdd.vue?vue&type=script&lang=js&"
export * from "./DataGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./DataGroupAdd.vue?vue&type=style&index=0&id=369bf370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369bf370",
  null
  
)

export default component.exports